import { Container, Text, Flex, Link, Icon, Box } from '@qga/roo-ui/components';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { DropdownOption } from '../../../types';
import isEmpty from 'lodash/isEmpty';
import { rem } from 'polished';
import type { FC } from 'react';

export interface DropdownProps {
  menuItems?: DropdownOption[];
  onClick: (x?: string) => void;
}

export const DropdownMenu: FC<DropdownProps> = ({
  menuItems = [],
  onClick,
}) => (
  <Container>
    <DropdownMenuWrapper>
      {menuItems.map(
        ({ children, submenu = [], trackingName, ...rest }, index) => (
          <DropdownColumn key={index}>
            {!!rest.href && (
              <Box onClick={() => onClick(trackingName)}>
                <TitleLink {...rest} data-testid="title-with-link">
                  <Text fontSize="base" mr={3}>
                    {children}
                  </Text>
                  <Icon name="chevronRight" color="greys.steel" size={16} />
                </TitleLink>
              </Box>
            )}
            {!rest.href && (
              <TextTitle data-testid="text-only-title">{children}</TextTitle>
            )}
            {!isEmpty(submenu) && (
              <Flex flexDirection="column" data-testid="dropdown-sub-lists">
                {submenu.map((subMenuItem, submenuIndex) => (
                  <Box
                    onClick={() => onClick(subMenuItem.trackingName)}
                    key={submenuIndex}
                  >
                    <DropdownPageLink {...subMenuItem} mt={2} />
                  </Box>
                ))}
              </Flex>
            )}
          </DropdownColumn>
        )
      )}
    </DropdownMenuWrapper>
  </Container>
);

const DropdownMenuWrapper = styled(Flex)`
  position: absolute;
  box-shadow: ${themeGet('shadows.modal')};
  z-index: ${themeGet('zIndices.modal')};
  width: ${rem('500px')};
  margin-left: -${themeGet('space.3')};
  border: solid 1px ${themeGet('colors.greys.alto')};
  border-top: 0;
  background-color: ${themeGet('colors.white')};
`;

const DropdownColumn = styled(Flex)`
  width: 100%;
  flex-direction: column;
  padding: ${themeGet('space.6')};
  color: ${themeGet('colors.greys.steel')};
`;

const TitleLink = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 1px ${themeGet('colors.greys.porcelain')};
  padding-bottom: ${themeGet('space.2')};
  color: inherit;

  &:hover {
    color: ${themeGet('colors.brand.primary')};
  }
`;

const TextTitle = styled(Text)`
  font-size: ${themeGet('fontSizes.base')};
  border-bottom: solid 1px ${themeGet('colors.greys.porcelain')};
  padding-bottom: ${themeGet('space.2')};
  color: inherit;
`;

const DropdownPageLink = styled(Link)`
  font-size: ${themeGet('fontSizes.sm')};
  color: inherit;

  &:hover {
    color: ${themeGet('colors.brand.primary')};
  }
`;
